import { useState } from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

import { Icon } from '@karehero/llama/components/atoms/Icon/Icon';

import { inFrameDialogProps } from '@/designs-dev/device/inFrameDialog';

// Create / rename shortlist modal (create copy from Figma 303:26383).
//
// Lifted out of CareSearch so the shortlists tab opens the same dialog rather
// than a second one that asks the same question. A shortlist is named here and
// nothing else: what care it is for and where come off the search that filled it,
// and the providers on it are added from the results.
//
// Mount it only while it is open, or key it on the mode — the name field seeds
// once, so a modal left mounted reopens holding the last thing typed into it.
const ShortlistModal = ({
  open,
  mode,
  initialName,
  inFrame,
  onClose,
  onSubmit,
}: {
  open: boolean;
  mode: 'create' | 'edit';
  initialName: string;
  inFrame?: boolean;
  onClose: () => void;
  onSubmit: (name: string) => void;
}) => {
  const [value, setValue] = useState(initialName);
  const isCreate = mode === 'create';
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='xs'
      fullWidth
      {...(inFrame ? inFrameDialogProps : {})}
    >
      <DialogTitle>
        <Stack
          sx={{ alignItems: 'center', justifyContent: 'space-between' }}
          direction='row'
        >
          <Typography variant='h3' color='primary.main'>
            {isCreate ? 'Create shortlist' : 'Edit shortlist'}
          </Typography>
          <IconButton aria-label='close' onClick={onClose}>
            <Icon icon='xmark' fontSize={18} />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent>
        <Stack spacing={2}>
          <Typography variant='subtitle1'>
            {isCreate
              ? 'Create a shortlist and start adding care options. When you are done, publish the shortlist so the care circle can view it.'
              : 'Rename your shortlist so the care circle can find it.'}
          </Typography>

          <TextField
            fullWidth
            label='Name'
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button variant='outlined' color='primary' onClick={onClose}>
          Discard
        </Button>
        <Button
          variant='contained'
          color='primary'
          onClick={() => onSubmit(value)}
        >
          {isCreate ? 'Create shortlist' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ShortlistModal.displayName = 'ShortlistModal';
export default ShortlistModal;
